const nomesTiposCategoria: Record<string, string> = {
  simples: 'Simples',
  pizzas: 'Pizza',
  complementos: 'Complementos',
};

export function nomeTipoCategoria(tipo: unknown): string | undefined {
  return typeof tipo === 'string' && Object.prototype.hasOwnProperty.call(nomesTiposCategoria, tipo)
    ? nomesTiposCategoria[tipo]
    : undefined;
}
